import React, { useState } from 'react'
import styles from './index.module.less'

export default function Enroll() {
  const [data, setData] = useState([
    { id: 1, flag: false, title: '取消', text: '此次会议不接受会议通票退款。' },
    { id: 2, flag: false, title: '替换', text: '会议通票可转移至同一企业下其他同事，或您可在一年内转移至iMFG其他系列活动参与。如需替换，请至少提前个工作日通知组委会以便我们实时同步注册系统方便您或相关替换同事快速与会签到。若未提前告知且出席，则无法享有替换权益。' },
    { id: 3, flag: false, title: '注意事项 ', text: '发言人与议程实时更新。若部分演讲集嘉宾临时取消，我们将积极寻找同等级别或同等影响力的替代者。如果会议因任何原因取消召开，组委会的责任仅限于退还会议通票注册费用。您承认已知晓，无任何追加条件并授权主办方可与会议当日现场拍摄、录制可能包含您的音频、视频、图片素材，且今后可用于iMFG系列活动的宣传与推广。' },
  ])
  const show = (e) => {
    switch (e) {
      case 1:
        setData(() => {
          data[0].flag = !data[0].flag
          return [...data]
        })
        break;
      case 2:
        setData(() => {
          data[1].flag = !data[1].flag
          return [...data]
        })
        break;
      case 3:
        setData(() => {
          data[2].flag = !data[2].flag
          return [...data]
        })
        break;
      default:
        break;
    }
  }
  return (
    <div style={{ backgroundColor: '#F4F9FE' }}>
      <div className={styles.cont}>
        <span className={styles.big_title}>会议通票</span>
        <div className={styles.ticket}>
          <div className={styles.item1}>
            <p className={styles.title}>免费参会</p>
            <p>0元/位</p>
            <button className={styles.btn}>免费报名</button>
            <p>限10月30日截至</p>
            <hr />
            <ul>
              <li>1天会议</li>
              <li>技术秀参观</li>
              <li>展区参观</li>
              <li>茶歇交流</li>
              <li>免费注册与签到通道</li>
              <li>电子会议会刊</li>
              <li><s>五星自助午宴</s></li>
              <li><s>同声传译</s></li>
              <li><s>会后全套可公布PPT</s></li>
              <li><s>一对一商务引荐</s></li>
              <li><s>高层闭门交流</s></li>
              <li><s>SVIP专属交流群</s></li>
              <li><s>会后引荐</s></li>
            </ul>
          </div>
          <div className={styles.item2}>
            <p className={styles.title}>VIP代表参会</p>
            <p>0元/位&nbsp;(仅限金融/医药/制造甲方业务决策层)<s>3,000元/位</s></p>
            <button className={styles.btn}>即刻注册</button>
            <p>10月30日恢复原价</p>
            <hr />
            <ul>
              <li>1天会议</li>
              <li>3个专场自由进出</li>
              <li>展区参观</li>
              <li>茶歇交流</li>
              <li>专属注册与签到通道</li>
              <li>纸质会议会刊</li>
              <li>茶歇糕点</li>
              <li>专属会议胸卡</li>
              <li>专属席卡与坐席</li>
              <li>五星自助午宴</li>
              <li>同声传译</li>
              <li>会后全套可公布PPT</li>
              <li><s>一对一商务引荐</s></li>
              <li><s>高层闭门交流</s></li>
              <li><s>SVIP专属交流群</s></li>
              <li><s>会后引荐</s></li>
            </ul>
          </div>
          <div className={styles.item2}>
            <p className={styles.title}>SVIP参会贵宾</p>
            <p>3,000元/位&nbsp;<s>6,800元/位</s></p>
            <button className={styles.btn}>即刻注册</button>
            <p>10月30日恢复原价</p>
            <hr />
            <ul>
              <li>1天会议</li>
              <li>3个专场自由进出</li>
              <li>展区参观</li>
              <li>茶歇交流</li>
              <li>专属注册与签到通道</li>
              <li>纸质会议会刊</li>
              <li>茶歇糕点</li>
              <li>专属会议胸卡</li>
              <li>专属席卡与坐席</li>
              <li>五星自助午宴</li>
              <li>同声传译</li>
              <li>会后全套可公布PPT</li>
              <li>一对一商务引荐</li>
              <li>高层闭门交流</li>
              <li>SVIP专属交流群</li>
              <li>会后引荐</li>
            </ul>
          </div>
        </div>
        <div className={styles.terms}>
          <h1>服务条款</h1>
          {
            data.map(i => (
              <div className={styles.item} key={i.id} onClick={() => { show(i.id) }}>
                <span>{i.title}{i.flag === false ? '▷' : '∇'}</span>
                <p style={{ display: i.flag === false ? 'none' : 'block' }}>{i.text}</p>
                <hr />
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}
